import { useField } from 'formik';
import { Form, Label } from 'semantic-ui-react';

interface Props {
  placeholder: string;
  name: string;
  rows: number;
  label?: string;
  changeHandler?: (data: string) => void;
}

const MyTextArea = ({
  placeholder,
  name,
  rows,
  label,
  changeHandler,
}: Props) => {
  const [field, meta, helpers] = useField(name);
  const propsForField = { placeholder, name, rows, label };

  return (
    <Form.Field error={meta.touched && !!meta.error}>
      <label>{label}</label>
      <textarea
        {...field}
        {...propsForField}
        onChange={(e) => {
          helpers.setValue(e.target.value);
          if (changeHandler) {
            changeHandler(e.target.value);
          }
        }}
      />
      {meta.touched && meta.error ? (
        <Label basic color='red'>
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
};

export default MyTextArea;
